import { getLeaveSettings } from '@/api/leave-settings';
import { QueryKeys } from '@gokrew/ui/constants/query-keys';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type { LeaveSettingsResponse } from '@gokrew/models/leave-settings';

export function useLeaveSettings(
  options?: Omit<UseQueryOptions<LeaveSettingsResponse>, 'queryKey' | 'queryFn'>
) {
  return useQuery<LeaveSettingsResponse>({
    queryKey: [QueryKeys.LeaveSettings],
    queryFn: () => getLeaveSettings(),
    ...options,
  });
}
